<template>
  <div class="box-detail procedures">
    <div class="box-left">
      <div class="box-left-header">
        <div @click="$router.push({ path: '/Procedures' })" class="goBack c-position-static c-m-0">
          <i class="el-icon-arrow-left"></i>
          <span>工序管理</span>
        </div>
      </div>
      <div class="box-left-content">
        <c-form
          :formData="formData"
          :fields="extFields"
          :options="options"
          ref="form"
          :upload="upload"
          labelWidth="110px"
          @changeForm="osg.changeForm"
        ></c-form>
      </div>
      <div class="box-left-footer">
        <el-button type="primary" @click="doSave()">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <div class="box-center">
      <el-tabs v-model="activeTab" @tab-click="tabClick">
        <el-tab-pane label="适用范围" name="scope">
          <div class="box-center-tool">
            <div></div>
            <div>
              <el-button type="primary" size="mini" @click="scopeSave">
                保存适用范围
              </el-button>
            </div>
          </div>
          <div class="box-center-content">
            <el-tree
              :data="scope.orgs"
              ref="scope"
              node-key="_id"
              :props="{ label: 'orgName', children: 'orgList' }"
              :expand-on-click-node="false"
              check-on-click-node
              show-checkbox
              default-expand-all
              :indent="50"
            ></el-tree>
          </div>
        </el-tab-pane>
        <el-tab-pane label="价格表" name="price">
          <div class="box-center-tool">
            <div></div>
            <div>
              <el-button type="primary" size="mini" @click="openPrice">
                添加价格
              </el-button>
              <el-dropdown
                class="c-m-l-10"
                @command="priceaudit"
                v-if="osg.has('Procedures,priceAudit')"
              >
                <el-button type="primary" size="mini">
                  审核
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="1">审核通过</el-dropdown-item>
                  <el-dropdown-item command="2">审核不通过</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="box-center-content settleTable">
            <el-table
              @selection-change="selectRows"
              ref="price"
              :data="price.fpi.data"
              border
              class="c-m-t-10"
            >
              <!-- 需加限制 -->
              <el-table-column
                v-if="osg.has('Procedures,priceAudit')"
                type="selection"
                width="55"
              ></el-table-column>
              <el-table-column label="组织" fixed width="250px">
                <template slot-scope="current">
                  <el-cascader
                    v-model="current.row.orgId"
                    :show-all-levels="false"
                    disabled
                    :options="scope.orgs"
                    :props="{
                      checkStrictly: true,
                      emitPath: false,
                      label: 'orgName',
                      value: '_id',
                      children: 'orgList'
                    }"
                    clearable
                  ></el-cascader>
                </template>
              </el-table-column>
              <el-table-column prop="guideUnitPrice" label="单价" width="150"></el-table-column>
              <el-table-column
                prop="minimumGuideTotalPrice"
                label="起算价"
                width="150"
              ></el-table-column>
              <el-table-column
                prop="approveState"
                label="审核状态"
                :formatter="formatApproveState"
                width="150"
              ></el-table-column>

              <!-- 操作2 -->
              <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                  <el-button @click="priceEdit(scope.row)" size="mini">
                    编辑
                  </el-button>
                  <el-button
                    @click="priceDelete(scope.row._id)"
                    size="mini"
                    style="margin-left:10px"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <el-dialog title="新增价格" :visible.sync="price.open">
            <el-form
              :model="price.formData"
              :rules="rules"
              ref="priceFormData"
              label-width="110px"
              label-position="left"
            >
              <el-form-item
                label="组织"
                prop="orgId"
                :rules="{
                  required: true,
                  trigger: ['change'],
                  message: '请选择组织'
                }"
              >
                <el-cascader
                  v-model="price.formData.orgId"
                  :options="scope.orgs"
                  :props="{
                    checkStrictly: true,
                    emitPath: false,
                    label: 'orgName',
                    value: '_id',
                    children: 'orgList'
                  }"
                  clearable
                ></el-cascader>
              </el-form-item>

              <el-form-item
                label="单价"
                prop="guideUnitPrice"
                :rules="{
                  required: true,
                  trigger: ['input'],
                  message: '请输入单价'
                }"
              >
                <el-input v-model="price.formData.guideUnitPrice" type="number"></el-input>
              </el-form-item>

              <el-form-item
                label="起算价"
                prop="minimumGuideTotalPrice"
                :rules="{
                  required: true,
                  trigger: ['input'],
                  message: '请输入起算价'
                }"
              >
                <el-input v-model="price.formData.minimumGuideTotalPrice" type="number"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer">
              <el-button type="primary" @click="priceSave()">提 交</el-button>
              <el-button @click="doInit">取 消</el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="业务动态" name="log">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getLog"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入标题/内容"
                v-model="log.searchValue"
                class="search-input"
                clearable
                @clear="getLog"
                @keyup.enter.native="getLog"
              >
                <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-monitor c-w-30"></i>
                  {{ log.title }}
                </span>
                <span>{{ log.createTime }}</span>
              </div>
              <div class="activity-card-content">
                {{ log.content }}
              </div>
              <div class="activity-card-footer">
                <span>操作人：{{ log.updateUserName }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="变更记录" name="history">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Procedures',
  data() {
    window.$this = this;
    return {
      id: null,
      tenantId: '',
      loginOrgId: '',
      formData: {
        exts: {}
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      fieldsObj: {},
      options: {
        codecfg_auditStatus: { codeId: 'auditStatus' }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: window.$this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      rules: this.$util.rules,
      activeTab: 'scope',
      scope: {
        open: false,
        orgs: []
      },
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      price: {
        fpi: { pages: 1, rows: 10, data: [] },
        formData: {},
        open: false,
        searchValue: '',
        selectedRows: []
      }
    };
  },
  mounted() {
    this.id = this.osg.param('id');
    // 获取当前租户id和登录人组织id
    let account = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = account.tenantId;
    this.loginOrgId = account.orgId;
    this.doInit();

    this.osg.getFields('procedure', () => {
      this.getData(() => {
        this.getOrgs(() => {
          // 自动勾选已选中的组织
          this.$refs.scope.setCheckedKeys(this.formData.scopeJson || []);
        });
      });
    });
  },
  methods: {
    formatApproveState(row, column, cellValue) {
      return this.osg.codelabel('auditStatus', cellValue);
    },
    getData(callback) {
      this.osg.ajax(
        `biz/procedure/findById/${this.id}.do`,
        {},
        res => {
          res.entity.exts = res.entity.exts || {};
          let formData = res.entity;
          this.$util.renderExtField(this.extFields, formData);
          this.formData = formData;
          if (callback) callback(res);
        },
        {
          noload: true
        }
      );
    },

    doSave() {
      if (this.osg.validate()) {
        let params = this.$util.deepCopy(this.formData);
        params.approveState = 0;

        // 超级管理员、平台管理员、当前组织都可以看到此条数据
        params.scopeIds = params.scopeIds || [];
        // if (params.scopeIds.indexOf('0') == -1) params.scopeIds.push('0');
        // if (params.scopeIds.indexOf(this.tenantId) == -1) params.scopeIds.push(this.tenantId);
        // if (params.scopeIds.indexOf(this.loginOrgId) == -1) params.scopeIds.push(this.loginOrgId);
        this.$util.saveExtField(this.extFields, params);
        this.osg.ajax(
          'biz/procedure/upsert.do',
          params,
          () => {
            this.osg.toast('保存成功！');
            this.getData();
          },
          {
            noload: true
          }
        );
      }
    },

    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'procedure',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          }
        },
        { noload: true }
      );
    },
    // 点击标签栏
    tabClick(tab) {
      switch (tab.name) {
        case 'scope':
          // 自动勾选已选中的组织
          this.$refs.scope.setCheckedKeys(this.formData.scopeJson || []);
          break;
        case 'price':
          this.getPrice();
          break;
        case 'log':
          this.getLog();
          break;
        case 'history':
          this.getHistory();
          break;
        default:
      }
    },
    /**
     * 适用范围
     */
    getOrgs(callback) {
      this.osg.ajax(
        'org/query.do',
        {
          notFilterOrgId: '1',
          sortField: 'order'
        },
        res => {
          res.data.orgName = '全部组织';
          this.scope.orgs = [res.data];
          if (callback) callback();
        }
      );
    },
    scopeSave() {
      this.formData.scopeJson = this.$refs.scope.getCheckedKeys(true); // true:仅返回全选中的叶子节点的keys false:返回所有全选中的节点
      let scopeIds = this.$refs.scope.getCheckedKeys();
      if (!scopeIds.length == 0) {
        // .concat(this.$refs.scope.getHalfCheckedKeys());
        // if(scopeIds.indexOf('0') == -1)scopeIds.push('0');    1340835581184723420
        this.formData.scopeIds = scopeIds;
      } else {
        this.formData.scopeIds = [this.tenantId];
      }
      this.doSave();
    },
    getPrice() {
      let params = {
        page: this.price.fpi.page,
        rows: this.price.fpi.rows,
        'is:procedureId|string#and': this.formData._id,
        'regex:name|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      this.osg.ajax('biz/procedure/body/query.do', params, res => {
        // 解析json字符串的字段
        this.$util.renderExtFields(this.extFields, res.data);
        this.price.fpi = res;
        this.$nextTick(() => {
          this.$refs.price.doLayout();
          this.$forceUpdate();
        });
      });
    },
    priceSave() {
      if (this.osg.validate('priceFormData')) {
        let params = this.price.formData;
        params.procedureId = this.formData._id;
        params.approveState = 0; //修改数据时审核状态改为0
        this.osg.ajax(
          'biz/procedure/body/upsert.do',
          params,
          () => {
            this.osg.toast('保存成功！');
            this.price.open = false;
            this.price.formData = {};
            this.doInit();
            this.getPrice();
          },
          {
            noload: true
          }
        );
      }
    },
    doInit() {
      // this.formData = {scopeIds:[], exts: {} };
      this.price.open = false;
      //  this.price.open = true;
      // this.$util.renderExtField(this.extFields, this.formData);
    },
    openPrice() {
      this.price.formData = this.$util.deepCopy();
      this.price.open = true;
    },
    priceEdit(row) {
      this.price.formData = this.$util.deepCopy(row);
      this.price.open = true;
    },
    priceDelete(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(`biz/procedure/remove/body/${id}.do`, null, () => {
          this.osg.toast('删除成功');
          this.getPrice();
        });
      });
    },
    // 列表多选
    selectRows(rows) {
      this.price.selectedRows = rows;
    },
    //审核
    priceaudit(approveState) {
      /**
       * auditStatus
       * 0:待审核（新建后是自由态-->审核状态设为0:待审核）
       * 1:审核通过（平台点审核通过-->审核状态改为1:审核通过）
       * 2:审核不通过（平台点审核通过-->审核状态改为2:审核不通过）
       */
      // 至少选择一个产品
      if (this.price.selectedRows.length == 0) {
        this.osg.toast('请至少勾选一条待审核的数据', 'warning');
        return;
      }
      // 判断选择的产品状态是否符合审核条件
      let msg = '';
      let confirmMsg = '';
      switch (approveState) {
        case '1':
          for (let row of this.price.selectedRows) {
            if (row.approveState != '0') {
              this.osg.alert(`您选择的“${row.name}”，不是“待审核”状态！`);
              return;
            }
          }
          confirmMsg = '审核通过';
          msg = '审核通过，处理完成。';
          break;
        case '2':
          for (let row of this.price.selectedRows) {
            if (row.approveState != '0') {
              this.osg.alert(`您选择的“${row.name}”，不是“待审核”状态！`);
              return;
            }
          }
          confirmMsg = '审核不通过';
          msg = '审核不通过，处理完成。';
          break;
        default:
      }
      this.osg.confirm(`是否确认“${confirmMsg}”？`, () => {
        this.auditConfirm(approveState, msg);
      });
    },
    auditConfirm(approveState, msg) {
      let ids = [];
      this.price.selectedRows.map(item => {
        ids.push(item._id);
      }),
        this.osg.ajax(
          'biz/procedure/approve/body.do',
          {
            ids: ids.join(),
            approveState: approveState
            // data: JSON.stringify({
            //   datas: this.price.selectedRows,
            //   newAuditStatus: approveState,
            //   // remark: this.auditObj.remark || null
            // })
          },
          () => {
            this.osg.toast(msg);
            // this.auditObj.remark = '';
            // this.auditObj.show = false;
            this.getPrice();
          }
        );
    }
  }
};
</script>
<style lang="scss">
.procedures {
  .el-tabs {
    height: 100%;
    display: flex;
    flex-direction: column;
    .el-tabs__content {
      flex: 1;
      .box-center-content {
        flex: 1;
        overflow-y: auto;
      }
    }
  }
}
</style>
